export const getAddress = () => {
  const currentYear = new Date().getFullYear();

  return `© ${currentYear} smava.de | Palisadenstraße 90 | 10243 Berlin`;
};
